import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../components/Reveal";

const HEADSHOT =
  "https://customer-assets.emergentagent.com/job_premium-web-33/artifacts/vk69ncxi_Photoroom_20260709_213048.webp";

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="bg-charcoal pt-40 pb-24">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal className="max-w-3xl">
            <span className="font-display text-sm uppercase tracking-widest font-semibold text-sky-brand">About Us</span>
            <h1 className="font-display text-4xl md:text-6xl font-bold tracking-tight text-white mt-5 leading-tight">
              A local agency with a premium standard.
            </h1>
          </Reveal>
        </div>
      </section>

      <section className="bg-white py-24 md:py-32">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-3 gap-12 lg:gap-16 items-start">
          {/* Photo — ~1/3 */}
          <Reveal className="lg:col-span-1">
            <div className="overflow-hidden rounded-[2rem] shadow-[0_20px_50px_rgba(0,0,0,0.12)] bg-gray-100" data-testid="founder-photo">
              <img
                src={HEADSHOT}
                alt="Terrance Baylor, founder of Elevated Web"
                className="w-full h-full object-cover aspect-[4/5]"
              />
            </div>
          </Reveal>

          {/* Bio — ~2/3 */}
          <Reveal delay={0.15} className="lg:col-span-2">
            <h2 className="font-display text-3xl md:text-4xl font-semibold tracking-tight text-charcoal">
              Hi, I'm Terrance Baylor — founder of Elevated Web.
            </h2>
            <div className="mt-8 space-y-6 font-body text-lg text-gray-500 leading-relaxed" data-testid="founder-bio">
              <p>
                I'm a Houston-based web designer with a background in graphic design, photography, videography, and visual
                arts. I've spent years understanding how visuals capture attention and communicate trust — and I built
                Elevated Web to bring that same eye for detail to businesses that deserve a professional online presence.
              </p>
              <p>
                I started building websites for myself and people I knew, and I quickly realized how big the gap was between
                what businesses actually had online and what they deserved. Most business owners are incredibly good at what
                they do — but their online presence doesn't reflect that. That's the problem Elevated Web exists to solve.
              </p>
              <p>
                My goal is simple: to be the web partner businesses can actually rely on — someone who follows through,
                delivers quality, and builds something that works as hard as you do. When you work with Elevated Web you're
                not working with a faceless agency. You're working with me, directly, every step of the way.
              </p>
            </div>

            <Link
              to="/contact"
              data-testid="about-cta-button"
              className="font-display mt-10 bg-charcoal text-white hover:bg-sky-brand hover:text-charcoal transition-colors duration-300 font-semibold px-8 py-4 rounded-full inline-flex items-center gap-2"
            >
              Work With Me <ArrowRight size={18} />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
